<template>
  <div>
    <div class="reservation-container">
      <div class="reservation-img">
        <img src="../image/pc.jpg" v-if="$store.state.pageset.pcshow" />
        <img src="../image/pc.jpg" v-else />
      </div>
      <div class="reservation-container-form">
        <p class="p1">Today,{{ todayNumber }}people have placed orders for consultation</p>
        <p class="p2" v-animate="'queue-bottom'">Smart selection flash delivery, worry free inspection.</p>
        <p class="p2" v-animate="'queue-bottom'">Thank you for your attention!</p>
        <p class="p2" v-animate="'queue-bottom'">
          Please leave your information, we will contact you as soon as possible to discuss specific needs!
        </p>
        <el-form ref="form" :rules="formRules" :model="form">
          <el-form-item prop="name" v-animate="'queue-bottom'">
            <el-input v-model="form.name" placeholder="name"></el-input>
          </el-form-item>
          <el-form-item prop="corporateName" v-animate="'queue-bottom'">
            <el-input
              v-model="form.corporateName"
              placeholder="corporate name"
            ></el-input>
          </el-form-item>
          <el-form-item v-animate="'queue-bottom'" prop="phone">
            <el-input v-model="form.phone" placeholder="phone number"></el-input>
          </el-form-item>

          <el-form-item prop="usageScenario" v-animate="'queue-bottom'">
            <el-input v-model="form.usageScenario" placeholder="Usage scenario"></el-input>
          </el-form-item>
          <el-form-item v-animate="'queue-bottom'" prop="intendedProduct">
            <el-select
              style="width: 100%"
              v-model="form.intendedProduct"
              placeholder="Intended products"
            >
              <el-option
                v-for="item in productOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="serviceSelection" v-animate="'queue-bottom'">
            <el-select
              style="width: 100%"
              v-model="form.serviceSelection"
              placeholder="service selection"
            >
              <el-option
                v-for="item in intentionOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button
          size="small"
          class="btn-div-experience black-btn"
          plain
          @click="orderNow"
          :loading="orderLoading"
          >Order Now</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import index from "./index.js";

export default index;
</script>
<style scoped lang="scss">
@import "index.scss";
@import "@/assets/style/common.scss";
@import "../index.scss";
</style>
